import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiRequest, formatPrice } from "../../api/client";
import LoadingSpinner from "../../components/ui/LoadingSpinner";
import { useAuth } from "../../context/AuthContext";

export default function AdminHome() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;

    apiRequest("/api/orders/admin/stats", { tokenType: "admin" })
      .then((response) => {
        if (isMounted) setStats(response.data);
      })
      .catch((err) => {
        if (!isMounted) return;
        if (err.status === 401 || err.status === 403) {
          auth.adminLogout();
          navigate("/admin/login", { replace: true });
          return;
        }
        setError(err.message);
      });

    return () => {
      isMounted = false;
    };
  }, [auth, navigate]);

  if (error) return <p className="form-status error">{error}</p>;
  if (!stats) return <LoadingSpinner label="Loading dashboard" />;

  return (
    <div className="admin-page">
      <div className="admin-page-head">
        <div>
          <span className="eyebrow">Overview</span>
          <h1>Dashboard Home</h1>
        </div>
      </div>
      <div className="admin-stat-grid">
        <Stat label="Products" value={stats.totalProducts} />
        <Stat label="Orders" value={stats.totalOrders} />
        <Stat label="Revenue" value={formatPrice(stats.totalRevenue)} />
        <Stat label="Active Promo Codes" value={stats.activePromoCodes} />
      </div>
      <section className="admin-panel">
        <h2 style={{marginBottom:"20px"}}>Recent Orders</h2>
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead><tr><th>Order</th><th>Customer</th><th>Status</th><th>Total</th></tr></thead>
            <tbody>
              {stats.recentOrders.map((order) => (
                <tr key={order.id}>
                  <td>{order.order_number}</td>
                  <td>{order.customer_name}</td>
                  <td><span className={`status-pill status-${order.order_status}`}>{order.order_status}</span></td>
                  <td>{formatPrice(order.total)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}

function Stat({ label, value }) {
  return (
    <article className="admin-stat">
      <span>{label}</span>
      <strong>{value}</strong>
    </article>
  );
}
